import React from "react";

export default () => (
  <svg
    className="fill-current inline"
    width="18px"
    height="18px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M10,12.0004593 C10.552,12.0004593 11,12.4484593 11,13.0004593 C11,13.5524593 10.552,14.0004593 10,14.0004593 C9.448,14.0004593 9,13.5524593 9,13.0004593 C9,12.4484593 9.448,12.0004593 10,12.0004593 L10,12.0004593 Z M10,16.0004593 C11.654,16.0004593 13,14.6544593 13,13.0004593 C13,11.3464593 11.654,10.0004593 10,10.0004593 C8.346,10.0004593 7,11.3464593 7,13.0004593 C7,14.6544593 8.346,16.0004593 10,16.0004593 L10,16.0004593 Z M15,17.0004593 C15,17.5524593 14.552,18.0004593 14,18.0004593 L6,18.0004593 C5.448,18.0004593 5,17.5524593 5,17.0004593 L5,9.00045931 C5,8.44845931 5.448,8.00045931 6,8.00045931 L14,8.00045931 C14.552,8.00045931 15,8.44845931 15,9.00045931 L15,17.0004593 Z M8,4.00045931 C8,2.89745931 8.897,2.00045931 10,2.00045931 C11.103,2.00045931 12,3.00045931 12,4.00045931 L12,6.00045931 L8,6.00045931 L8,4.00045931 Z M14,6.00045931 L14,4.00045931 C14,1.75345931 11.739,-0.494540691 9.164,0.095459309 C7.266,0.530459309 6,2.34145931 6,4.28845931 L6,6.00045931 L5,6.00045931 C3.895,6.00045931 3,6.89545931 3,8.00045931 L3,18.0004593 C3,19.1054593 3.895,20.0004593 5,20.0004593 L15,20.0004593 C16.105,20.0004593 17,19.1054593 17,18.0004593 L17,8.00045931 C17,6.89545931 16.105,6.00045931 15,6.00045931 L14,6.00045931 Z"
      id="path-1"
    />
  </svg>
);
